import React, { Fragment } from 'react';
import spinner from './spinner.svg';

const Spinner = () => (
  <Fragment>
    <img src={spinner} alt='Loading...' className='mt-8 m-auto block' />
  </Fragment>
);

export default Spinner;
